var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, Input, InputGroup, InputLeftElement, InputRightElement, forwardRef, useMergeRefs, } from "@chakra-ui/react";
export const TextField = forwardRef((_a, ref) => {
    var { leftIcon = null, rightIcon = null, onClear, showClear = false, clearColor, size, label, errorText = "", isInvalid = false, isRequired = false, value, onFocus, onBlur, simple = false, dividerColor, noRightPadding } = _a, rest = __rest(_a, ["leftIcon", "rightIcon", "onClear", "showClear", "clearColor", "size", "label", "errorText", "isInvalid", "isRequired", "value", "onFocus", "onBlur", "simple", "dividerColor", "noRightPadding"]);
    const [isLabelActive, setLabelActive] = useState(false);
    const [labelOffset, setLabelOffset] = useState("");
    const inputRef = useRef(null);
    const [rightElementOffset, setRightElementOffset] = useState(0);
    const rightElementRef = useRef(null);
    const leftElementRef = useRef(null);
    function touchHandler(e) {
        if (inputRef && inputRef.current) {
            inputRef.current.blur();
        }
        e.preventDefault();
    }
    const onInputFocus = useCallback((e) => {
        document.addEventListener("touchmove", touchHandler, false);
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus]);
    const onInputBlur = useCallback((e) => {
        var _a;
        document.removeEventListener("touchmove", touchHandler);
        if (inputRef && inputRef.current && ((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value.length)) {
            setLabelActive(true);
        }
        else {
            setLabelActive(false);
        }
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur, inputRef]);
    useEffect(() => {
        var _a;
        setRightElementOffset((_a = rightElementRef === null || rightElementRef === void 0 ? void 0 : rightElementRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
    }, [rightElementRef]);
    useEffect(() => {
        var _a;
        setLabelOffset(`${((_a = leftElementRef === null || leftElementRef === void 0 ? void 0 : leftElementRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) - 15}px`);
    }, [leftElementRef]);
    const clearButton = (React.createElement(Button, { onClick: onClear, variant: "ghost", sx: {
            bg: "transparent",
            mr: "8px",
            color: clearColor,
        } }, "Clear"));
    const refs = useMergeRefs(ref, inputRef);
    const labelDefaultStyle = Object.assign(Object.assign({ zIndex: 2, color: "medium_gray", position: "absolute", left: 0 }, (leftIcon && labelOffset && { pl: labelOffset })), { top: "50%", transform: "translate(16px, -50%) scale(1)", m: "0px", bg: "transparent", visibility: simple && "hidden" });
    const labelActiveStyle = Object.assign(Object.assign({}, labelDefaultStyle), { transformOrigin: "top left", top: 0, transform: "translate(14px, -10px) scale(0.75)", bg: "white", pl: "xxsmall", pr: "xxsmall" });
    return (React.createElement(FormControl, { isInvalid: isInvalid, isRequired: isRequired },
        React.createElement(FormLabel, { sx: (value && value.toString().length) || isLabelActive
                ? labelActiveStyle
                : labelDefaultStyle, _invalid: { color: "error" }, _focus: Object.assign(Object.assign({}, labelActiveStyle), { color: "primary" }) }, label),
        React.createElement(InputGroup, { size: size },
            leftIcon ? (React.createElement(InputLeftElement, { ref: leftElementRef }, leftIcon)) : null,
            React.createElement(Input, Object.assign({ onFocus: onInputFocus, onBlur: onInputBlur, pr: showClear && rightIcon
                    ? `${rightElementOffset + 80}px`
                    : showClear || rightIcon
                        ? undefined
                        : 4, value: value }, rest, { ref: refs })),
            showClear || rightIcon ? (React.createElement(InputRightElement, { visibility: simple ? "hidden" : "visible", _groupHover: {
                    visibility: simple && "visible",
                }, width: "auto", height: "100%", pr: noRightPadding ? "0px" : simple ? "4px" : "16px", ref: rightElementRef },
                React.createElement(Flex, { justifyContent: "flex-end", alignItems: "center", flex: 1 },
                    showClear && clearButton,
                    showClear && (React.createElement(Box, { sx: {
                            width: "1px",
                            height: "16px",
                            mr: rightIcon ? "8px" : "0px",
                            borderRight: rightIcon ? "1px solid" : "none",
                            borderRightColor: dividerColor || "medium_gray",
                            opacity: ".5",
                        } })),
                    rightIcon))) : null),
        React.createElement(FormErrorMessage, { sx: {
                position: "absolute",
                fontSize: "xsm",
                pl: "16px",
                bottom: "-20px",
            } }, errorText)));
});
